import React, { useState } from 'react';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { IQuestionDetailAnswer } from '../../../../../store/QuestionSlice';
import AnswerOption from './AnswerOption';
import AddDetailModal from '../ManageDetails/modals/AddDetailModal';

interface IInitialDetailModalDataState {
  isVisible: boolean;
  answer: IQuestionDetailAnswer | undefined;
}
interface IInitialMenuData {
  isVisible: boolean;
  anchorEl: HTMLElement | null;
  answer: IQuestionDetailAnswer | undefined;
}

const initialDetailModalDataState: IInitialDetailModalDataState = {
  isVisible: false,
  answer: undefined,
};
const initialMenuDataState: IInitialMenuData = {
  isVisible: false,
  anchorEl: null,
  answer: undefined,
};

export interface IAnswerManager {
  answers: Array<IQuestionDetailAnswer>;
  addNewOption?: () => void;
  deleteOption: (order: number) => void;
  checkOption: (order: number) => void;
  updateContentOption: (order: number, html: string) => void;
  dragOptionToTop: (order: number) => void;
  dragOptionToDown: (order: number) => void;
}

const AnswerManager: React.FC<IAnswerManager> = ({
  answers,
  addNewOption,
  deleteOption,
  checkOption,
  updateContentOption,
  dragOptionToTop,
  dragOptionToDown,
}) => {
  // LOCAL STATES
  const [
    detailModalData,
    setDetailModalData,
  ] = useState<IInitialDetailModalDataState>(initialDetailModalDataState);
  const [menuData, setMenuData] = useState<IInitialMenuData>({
    ...initialMenuDataState,
  });

  // RENDER
  return (
    <div style={{ marginBottom: '15px' }}>
      <Typography fontWeight={600} sx={{ mb: '-8px' }}>
        Enter the options *
      </Typography>
      <Typography variant="caption" sx={{ mb: '5px' }}>
        Mark the correct option
      </Typography>
      <div>
        {answers.map((answer, index) => {
          return (
            <AnswerOption
              key={index}
              itemIndex={index}
              answer={answer}
              onDelete={() => deleteOption(index)}
              onChecked={() => checkOption(index)}
              onAddContent={() =>
                setDetailModalData({
                  answer,
                  isVisible: true,
                })
              }
              onMenuOpen={(event) => {
                if (answers.length > 1) {
                  setMenuData({
                    isVisible: true,
                    anchorEl: event,
                    answer,
                  });
                }
              }}
            />
          );
        })}
      </div>
      <div>
        <Button
          startIcon={<AddIcon />}
          sx={{ mt: '10px' }}
          onClick={addNewOption}
        >
          Add New
        </Button>
      </div>
      {detailModalData && detailModalData.isVisible && detailModalData.answer && (
        <AddDetailModal
          open={detailModalData.isVisible}
          onClose={() => setDetailModalData(initialDetailModalDataState)}
          details={detailModalData.answer.content}
          updateDetails={(html) => {
            if (detailModalData.answer && detailModalData.answer.order > -1) {
              updateContentOption(detailModalData.answer.order, html);
            }
            setDetailModalData(initialDetailModalDataState);
          }}
        />
      )}
      {menuData && menuData.isVisible && menuData.anchorEl && menuData.answer && (
        <Menu
          id="drag-option-menu"
          open={menuData.isVisible}
          anchorEl={menuData.anchorEl}
          onClose={() => setMenuData(initialMenuDataState)}
        >
          {menuData.answer.order > 0 && (
            <MenuItem
              onClick={() => {
                if (menuData.answer && menuData.answer.order) {
                  dragOptionToTop(menuData.answer.order);
                }
                setMenuData(initialMenuDataState);
              }}
            >
              Drag Top
            </MenuItem>
          )}
          {answers.length - 1 !== menuData.answer.order && (
            <MenuItem
              onClick={() => {
                if (menuData.answer && menuData.answer.order > -1) {
                  dragOptionToDown(menuData.answer.order);
                }
                setMenuData(initialMenuDataState);
              }}
            >
              Drag Down
            </MenuItem>
          )}
        </Menu>
      )}
    </div>
  );
};

export default AnswerManager;
